"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSipTrunkPhoneNumberRequest = void 0;
const core = __importStar(require("../../core"));
const InboundSipTrunkConfigRequestModel_1 = require("./InboundSipTrunkConfigRequestModel");
const OutboundSipTrunkConfigRequestModel_1 = require("./OutboundSipTrunkConfigRequestModel");
exports.CreateSipTrunkPhoneNumberRequest = core.serialization.object({
    phoneNumber: core.serialization.property("phone_number", core.serialization.string()),
    label: core.serialization.string(),
    supportsInbound: core.serialization.property("supports_inbound", core.serialization.boolean().optional()),
    supportsOutbound: core.serialization.property("supports_outbound", core.serialization.boolean().optional()),
    inboundTrunkConfig: core.serialization.property("inbound_trunk_config", InboundSipTrunkConfigRequestModel_1.InboundSipTrunkConfigRequestModel.optional()),
    outboundTrunkConfig: core.serialization.property("outbound_trunk_config", OutboundSipTrunkConfigRequestModel_1.OutboundSipTrunkConfigRequestModel.optional()),
});
